
/**
 * In Memory cache manager for handling Curveball.Storage.StoragEntry objects. Store, expire, retrieve data quickly in a standard wrapped object instance.
 * 
 * @name MemStorage
 * @implements Curveball.Storage
 * @memberOf Curveball
 * @requires  Curveball
 * @requires  Curveball.Storage
 */
define('mem-storage/mem-storage',['require','exports','module','abstract-storage/abstract-storage'],function(require,exports,module){

	var $Storage=require('abstract-storage/abstract-storage');

	if(!$Storage){
		throw new Error('abstract-storage not found.  Please check dependencies.');  
	}

		/**
		 * Internal cache for StorageEntry instances.
		 * It puts the "Mem" in MemStorage!
		 * @type {Object}
		 * @example : 
		 * {
		 * 		"namespace" : {
		 * 			"key" 	: {object StorageEntry}
		 * 			"key2"	: {object StorageEntry}
		 * 		},
		 * 		"namespace2": {
		 * 			"key2"	: {object StorageEntry}
		 * 		} 
		 * }
		 * @see Curveball.Storage#StorageEntry
		 */
	var items ={},
		/**
		 * StorageEntry management Abstract.
		 * @type {Object}
		 * @see Curveball.Storage
		 */
	    manager = $Storage;

	module.exports = {
		/**
		 * Create a new StorageEntry instance and place it in the 
		 * cache. @see items for example.
		 * 
		 * @param  {string} namespace Top-level container for object grouping.
		 * @param  {string} key       Primary storage key for individial objects.
		 * @param  {mixed} 	value     Data to be stored.
		 * @param  {number} expires   Time in seconds
		 * @param  {number} priority  [description]
		 * @return {object}           Returns a valid StorageEntry instance.
		 */
	    put : function(namespace, key, value, expires, priority) {
	        return (items[namespace]=items[namespace]||{})[key] = manager.storable(key,value,expires,priority);
	    },
        /**
         * Attempt to retrieve all items in the mem cache under the
         * provided namespace.
         * @param  {string} namespace   Namespace to retrieve.
         * @return {object}             Collection of retrieved items or empty object.
         */
        getAll: function(namespace) {
        	return items[namespace] || {};
        },
        /**
         * Attempt to retrieve a storage object from the mem cache items.
         * If expired as dicated by the created and expires properties,
         * the object will be marked accordingly via the expired property.
         * (If none exists, return an empty expired object)
         * 
         * @param  {object} so  A storage object to be evaluated for retrieval.
         * @uses   Curveball.Storage.get
	     * @see    Curveball.Storage.get
         * @return {object}     Object so or an "empty" storage object.
         */
	    get: function(namespace, key) {
	        var json = items[namespace] && items[namespace][key],
	            ret=manager.get(json);

	        if(ret.created===0){
	            //console.log('had to clear',namespace,key)
	            //this.clear(namespace,key);    
	        }
	        return ret; 
	    },
        /**
         * Mark a storage object as expired.
		 * @param {string} namespace Namespace of object to expire.
		 * @param {string} key 		Key of object to expire.
		 * @uses  Curveball.Memstorage.get
		 * @uses  Curveball.Storage.expire
         */
	    expire : function(namespace, key) {
	        var json=this.get(namespace,key);
	        manager.expire(json);
	    },
	    /**
	     * Remove object key from object namespace and the cache.
	     * @param  {string} namespace Namespace of targeted object.
	     * @param  {[type]} key       Key of target object.
	     */
	    clear: function(namespace, key) {
	        var nso=items[namespace];
	        if(nso){
	            delete nso[key];
	        }
	    },
	    /**
	     * Remove the given namespace and it's objects from the cache.
	     * @param  {string} namespace Namespace to clear.
	     */
	    clearAll:function(namespace) {
	        delete items[namespace];
	    },
	    /**
	     * Inspect the entire internal cache, or specific namespace.
	     * @return {object} internal cache structure
	     */
	    peek : function(namespace){
	        return namespace && items[namespace] || items;
	    }
	};
});
